import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/material';

export const CheckboxSquareLabel = styled(FormControlLabel)<{ active?: boolean }>(
  ({ theme, active }) => ({
    margin: 0,
    color: active ? theme.palette.primary.main : theme.palette.text.secondary,
    '&:hover': {
      color: active ? theme.palette.common.main2 : theme.palette.primary.main,
      '& .icon-active rect': {
        fill: theme.palette.common.main2,
      },
    },
    '& .MuiIconButton-root': {
      marginRight: theme.spacing(1),
    },
  }),
);
